import React from "react";
import Select from "react-select";
import { TableViewDialog, TableDialogFooter, TableDialogBtn } from "../style";
import { OptionImage } from "../../product/style";

const SectionPropertyDialog = ({
  group,
  tableManager,
  updateProperties,
  updateSectionProperties,
  mutateCurrentRoom,
  properties,
  setCurrentTab,
}) => {
  return (
    <TableViewDialog onClick={(e) => e.stopPropagation()}>
      <div className="d-flex flex-column row-gap-3">
        {properties.map((property, index) => {
          return (
            <div
              className={`${property.highlight ? "highlight_property" : ""}`}
            >
              <p className="grey_letter mb-1">{property.name}</p>
              {property.is_editable ? (
                <Select
                  autoFocus={index === 0 ? true : false}
                  className="list-summary-select"
                  key={index}
                  value={
                    property.options.find((option) => option.selected) || null
                  }
                  isDisabled={!property.is_editable}
                  onChange={(selectedOption) => {
                    if (selectedOption.identifier === "__add_more__") {
                      if (setCurrentTab) {
                        const subTab = property.identifier === "hinge" ? "hinges" : "drawers";
                        setCurrentTab("materials", subTab);
                      } else {
                        tableManager.clear();
                      }
                      return;
                    }
                    property.options.forEach((o) => {
                      o.selected = o.identifier == selectedOption.identifier;
                    });
                    mutateCurrentRoom();
                    const updateFunc = updateSectionProperties || updateProperties;
                    if (updateFunc) {
                      updateFunc({
                        id: group.id,
                        propIdentifier: property.identifier,
                        optionIdentifier: selectedOption.identifier,
                      });
                    }
                  }}
                  options={[
                    ...property.options.map((option, optionIndex) => {
                      option.value = option.name;
                      option.label = (
                        <div key={optionIndex}>
                          {option.image && (
                            <OptionImage
                              src={option.image}
                              alt={option.name}
                              className="border border-dark rounded-circle me-2"
                            />
                          )}
                          {option.name}
                        </div>
                      );
                      option.key = index;

                      return {
                        value: option.name,
                        label: option.name,
                        ...option,
                      };
                    }),
                    ...(() => {
                      const isHinge = property.identifier === "hinge" && property.is_editable;
                      const isDrawer = property.identifier === "drawer_mechanism_type" && property.is_editable;
                      if (isHinge) {
                        return [{
                          value: "... add more hinges",
                          label: "... add more hinges",
                          identifier: "__add_more__",
                          key: `add-more-hinge-${index}`,
                        }];
                      }
                      if (isDrawer) {
                        return [{
                          value: "... add more drawers",
                          label: "... add more drawers",
                          identifier: "__add_more__",
                          key: `add-more-drawers-${index}`,
                        }];
                      }
                      return [];
                    })()
                  ]}
                />
              ) : (
                <div className="mt-1 text-disabled">
                  {property.options.find((option) => option.selected)?.name ||
                    "No Value"}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <TableDialogFooter>
        <TableDialogBtn
          onClick={(e) => {
            e.stopPropagation();
            tableManager.clear();
          }}
          className="mt-3"
        >
          Done
        </TableDialogBtn>
      </TableDialogFooter>
    </TableViewDialog>
  );
};

export default SectionPropertyDialog;
